/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AiModelPricingListModel } from '../models/ai-model-pricing-list-model';
import { AiUsageCompanyLimitModel } from '../models/ai-usage-company-limit-model';
import { GetCompanyLimit } from '../fn/ai-usage/get-company-limit';
import { GetCompanyLimit$Params } from '../fn/ai-usage/get-company-limit';
import { GetModelPricing } from '../fn/ai-usage/get-model-pricing';
import { GetModelPricing$Params } from '../fn/ai-usage/get-model-pricing';
import { SaveCompanyLimit } from '../fn/ai-usage/save-company-limit';
import { SaveCompanyLimit$Params } from '../fn/ai-usage/save-company-limit';
import { SaveModelPricing } from '../fn/ai-usage/save-model-pricing';
import { SaveModelPricing$Params } from '../fn/ai-usage/save-model-pricing';

@Injectable({ providedIn: 'root' })
export class AiUsageApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAiUsageGetModelPricingGet()` */
  static readonly ApiAiUsageGetModelPricingGetPath = '/api/AIUsage/GetModelPricing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetModelPricing()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetModelPricing$Response(params?: GetModelPricing$Params, context?: HttpContext): Observable<StrictHttpResponse<AiModelPricingListModel>> {
    return GetModelPricing(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetModelPricing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetModelPricing(params?: GetModelPricing$Params, context?: HttpContext): Observable<AiModelPricingListModel> {
    return this.GetModelPricing$Response(params, context).pipe(
      map((r: StrictHttpResponse<AiModelPricingListModel>): AiModelPricingListModel => r.body)
    );
  }

  /** Path part for operation `apiAiUsageSaveModelPricingPost()` */
  static readonly ApiAiUsageSaveModelPricingPostPath = '/api/AIUsage/SaveModelPricing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveModelPricing()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveModelPricing$Response(params?: SaveModelPricing$Params, context?: HttpContext): Observable<StrictHttpResponse<AiModelPricingListModel>> {
    return SaveModelPricing(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveModelPricing$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveModelPricing(params?: SaveModelPricing$Params, context?: HttpContext): Observable<AiModelPricingListModel> {
    return this.SaveModelPricing$Response(params, context).pipe(
      map((r: StrictHttpResponse<AiModelPricingListModel>): AiModelPricingListModel => r.body)
    );
  }

  /** Path part for operation `apiAiUsageGetCompanyLimitGet()` */
  static readonly ApiAiUsageGetCompanyLimitGetPath = '/api/AIUsage/GetCompanyLimit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetCompanyLimit()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCompanyLimit$Response(params?: GetCompanyLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<AiUsageCompanyLimitModel>> {
    return GetCompanyLimit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetCompanyLimit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetCompanyLimit(params?: GetCompanyLimit$Params, context?: HttpContext): Observable<AiUsageCompanyLimitModel> {
    return this.GetCompanyLimit$Response(params, context).pipe(
      map((r: StrictHttpResponse<AiUsageCompanyLimitModel>): AiUsageCompanyLimitModel => r.body)
    );
  }

  /** Path part for operation `apiAiUsageSaveCompanyLimitPost()` */
  static readonly ApiAiUsageSaveCompanyLimitPostPath = '/api/AIUsage/SaveCompanyLimit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveCompanyLimit()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveCompanyLimit$Response(params?: SaveCompanyLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<AiUsageCompanyLimitModel>> {
    return SaveCompanyLimit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveCompanyLimit$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveCompanyLimit(params?: SaveCompanyLimit$Params, context?: HttpContext): Observable<AiUsageCompanyLimitModel> {
    return this.SaveCompanyLimit$Response(params, context).pipe(
      map((r: StrictHttpResponse<AiUsageCompanyLimitModel>): AiUsageCompanyLimitModel => r.body)
    );
  }

}
